module.exports = __webpack_public_path__ + "img/bullhorn.c3743b7d.svg";